export default "__VITE_ASSET__81cdf996__"